import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DemoUserDto, UserDto } from 'shared';
import { AccountService } from 'shared';
import { NotificationService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'demouser-management',
    templateUrl: './demouser-management.component.html',
    styleUrls: ['./demouser-management.component.css'],
    standalone: false
})
export class DemouserManagementComponent implements OnInit {

  demoUserProfileForm!: UntypedFormGroup;
  userProfile = new DemoUserDto();

  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private tenantService: TenantService,
    private accountService: AccountService,
    public translate: TranslateService,
    private notificationService: NotificationService
    ) {}

  ngOnInit() {
    this.createDemoUserProfileForm();
  }

  createDemoUserProfileForm() {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    this.demoUserProfileForm = this.formBuilder.group({
      email: [null, [Validators.required, Validators.pattern(emailregex)]],
      companyName: [null],
      isEmailConfirmed: [false],
      phoneNumber: [null],
      statusMessage: [null],
      fullName: [null],
      webSite: [null],
      profile: [null],
      streetAddress: [null],
      locality: [null],
      region: [null],
      postalCode: [null],
      country: [null],
      construction: false,
      infrastructure: false
    });
  }

  createDemouser(){
    if(this.demoUserProfileForm.valid) {
      this.userProfile.phoneNumber = this.demoUserProfileForm.value.phoneNumber;
      this.userProfile.userName = this.demoUserProfileForm.value.fullName;
      this.userProfile.email = this.demoUserProfileForm.value.email;
      this.userProfile.companyName = this.demoUserProfileForm.value.companyName;
      this.userProfile.buildingconstruction = this.demoUserProfileForm.value.construction;
      this.userProfile.infrastructure = this.demoUserProfileForm.value.infrastructure;

      console.log("-----> demouser-management.addUser(): userDto = ",this.userProfile)
      this.accountService.createDemoUser(this.userProfile, this.tenantService.currentTenantName).subscribe({
        next: (user) => {
          this.notificationService.success("", "Demo User erfasst");
          this.createDemoUserProfileForm();
          // this.demoUserProfileForm.reset();
          // this.demoUserProfileForm.value.construction = false;
          // this.demoUserProfileForm.value.infrastructure = false;
          //this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-demousers']);

          // this.rowData.splice(2, 0, user);
          // this.rowData.push(user);            
          // this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERADDED"]}`);
          //this.gridApi.refreshInfiniteCache();
        },
        error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERADDEDERROR"]}`)
      });
  }



  }

}
